import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteFaq,
  patchFaqStatus,
  updateFaq,
  insertFaq,
  fetchFaqsByIctId,
} from "../../../../../store/ictFaqSlice";
const user = JSON.parse(localStorage.getItem("user"));
const username = user?.username || null;
const userRole = user?.role || null;
const isReadOnly = userRole === "sales";

const IctFaq = ({ ictId, onClose, showInsertForm = false }) => {
  const dispatch = useDispatch();
  const { faqs = [] } = useSelector((state) => state.ictFaq || {});
  const { user } = useSelector((state) => state.auth);

  const [editId, setEditId] = useState(null);
  const [editQ, setEditQ] = useState("");
  const [editA, setEditA] = useState("");
  const [editType, setEditType] = useState("subjective");

  const [newQ, setNewQ] = useState("");
  const [newA, setNewA] = useState("");
  const [newType, setNewType] = useState("subjective");

  useEffect(() => {
    if (ictId && !showInsertForm) {
      dispatch(fetchFaqsByIctId(ictId));
    }
  }, [dispatch, ictId, showInsertForm]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this FAQ?")) {
      dispatch(deleteFaq(id));
    }
  };

  const handleStatusToggle = (item) => {
    const newStatus = item.status === "A" ? "D" : "A";
    dispatch(patchFaqStatus({ faq_id: item.id, status: newStatus }));
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setEditQ(item.faq);
    setEditA(item.faqAnswer);
    setEditType(item.faqType);
  };

  const handleSave = (item) => {
    dispatch(
      updateFaq({
        id: item.id,
        faq: editQ,
        faqAnswer: editA,
        faqType: editType,
      })
    );
    setEditId(null);
    setEditQ("");
    setEditA("");
    setEditType("subjective");
  };

  const handleInsert = () => {
    if (newQ.trim() && newA.trim()) {
        dispatch(
        insertFaq({
            ictId_id: parseInt(ictId),
            faq: newQ,
            faqAnswer: newA,
            faqType: newType,
            status: "A",
            user: username // <== this line
        })
        );
        setNewQ("");
        setNewA("");
        setNewType("subjective");
        onClose();
    }
  };
  

  return (
    <div className="popup-overlay">
      <div className="popup-content large">
        <div className="popup-header">
          <h3>
            {showInsertForm ? "Add FAQ" : `FAQs for ICT ID: ${ictId}`}
            <button className="close-btn" onClick={onClose}>
              <i className="fa fa-times"></i>
            </button>
          </h3>
        </div>

        {showInsertForm ? (
          <div>
            <div className="form-group">
            <label>FAQ Type:</label>  
            <select 
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
              className="form-group"
            >
              <option value="subjective">Subjective</option>
              <option value="objective">Objective</option>
              <option value="suggestive">Suggestive</option>
            </select>
            </div>
            
            <div className="form-group">
                
            <label>FAQ Details:</label>
            <textarea
              placeholder="Type your FAQ question..."
              value={newQ}
              cols={50}
              rows={3}
              onChange={(e) => setNewQ(e.target.value)}
              className="input full-width"
            />
            </div>
            
            <div className="form-group">
            <textarea
              placeholder="Type your FAQ answer..."
              value={newA}
              cols={50}
              rows={3}
              onChange={(e) => setNewA(e.target.value)}
              className="textarea full-width"
            />
            </div>
            <hr />
            <button onClick={handleInsert}>Insert</button>
          </div>
        ) : (
          <>
            {faqs.length === 0 ? (
              <p>No FAQs found.</p>
            ) : (
              <table className="table styled-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Type</th>
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Status</th>
                    <th>Posted By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {faqs.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {editId === item.id ? (
                          <select
                            value={editType}
                            onChange={(e) => setEditType(e.target.value)}
                          >
                            <option value="subjective">Subjective</option>
                            <option value="objective">Objective</option>
                            <option value="suggestive">Suggestive</option>
                          </select>
                        ) : (
                          item.faqType
                        )}
                      </td>
                      <td>
                        {editId === item.id ? (
                          <input
                            type="text"
                            value={editQ}
                            onChange={(e) => setEditQ(e.target.value)}
                          />
                        ) : (
                          item.faq
                        )}
                      </td>
                      <td>
                        {editId === item.id ? (
                          <textarea
                            rows={2}
                            value={editA}
                            onChange={(e) => setEditA(e.target.value)}
                          />
                        ) : (
                          item.faqAnswer
                        )}
                      </td>
                      <td>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.status === "A"}
                            onChange={() => handleStatusToggle(item)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td>{item.user}</td>
                      <td>
                        {!isReadOnly && editId === item.id ? (
                          <i
                            className="fa fa-save action-icon saveIcon"
                            onClick={() => handleSave(item)}
                          ></i>
                        ) : (
                         <>
                          {!isReadOnly && (
                              <i
                              className="fa fa-edit action-icon editIcon"
                              onClick={() => handleEdit(item)}
                              ></i>
                            )}
                         </>
                        )}
                        {!isReadOnly && (
                        <i
                            className="fa fa-trash action-icon deleteIcon"
                            onClick={() => handleDelete(item.id)}
                        ></i>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default IctFaq;
